import React from "react";
import { cx } from "@/utils/classnames";

export const ChalkSqlIcon: React.FC<React.ComponentProps<"svg">> = ({ className, ...props }) => (
  <svg
    aria-hidden="true"
    className={cx("!text-black dark:!text-white", className)}
    data-sql-datasource-icon="chalk"
    viewBox="0 0 12 12"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect width="12" height="12" fill="currentColor" />
  </svg>
);
